<script>
    export let company_data;
    function scrowTo(elementId) {
		let element = document.getElementById(elementId)
		if (element){
			element.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}
    let effect_phrase = company_data.landing_page.effect_phrase;
    let company_name = company_data.name;
    let description = company_data.landing_page.description;
    let delivery_url = company_data.delivery_url;
</script>

<style>
    .banner-area {
        background: url(../img/header-bg.jpg) right;
        background-size: cover;
        padding-top: 200px;
        height: 850px;
        font-family: "Poppins", sans-serif;
    }

    @media (max-width: 991.98px) {
        .banner-area {
            background: url(../img/header-bg.jpg) right;
            background-size: auto;
            padding-top: 50px;
            width: 100%;
            font-family: "Poppins", sans-serif;
        } 

        .text-box {
            background-color: black;
            color: #fff; 
            /* display: inline; */
            padding: 0.5rem;
            
            -webkit-box-decoration-break: clone;
            box-decoration-break: clone;

        }

        .banner-area-top-text {
            font-size: 15px !important;
        }

        .banner-area-company {
            font-size: 45px !important;
        }

        .banner-area-description { 
            font-size: 15px !important;
        }
    }

    

    .banner-content {
        padding-top: 100px;
        padding-left: 0;
        line-height: 1.625em;
        /* text-shadow: 0 1px 0 black; */
        
    }

    .banner-area-top-text {
        font-size: 18px;
        font-weight: 300;
        letter-spacing: 3px;
        color: white;
    }

    .banner-area-company {
        font-family: "Poppins", sans-serif;
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 60px;
        color: white;
        font-weight: 700;
        line-height: 1.2em !important;
    }

    .banner-area-description {
        margin-bottom: 1rem;
        color: white !important;
        font-size: 14px;
        font-weight: 300;
        line-height: 1.625em;
        box-sizing: border-box;
    }

    .landing-btn {
        background-color: #f42f2c;
        border-radius: 25px;
        padding: 10px 30px 10px 30px;
        border: 1px solid transparent;
        color: #fff;
        font-size: 14px;
    }

    .btn:hover {
        color: #fff;
        background-color: #0000003a;
        border-color: white;
    }
</style>

<section class="banner-area relative" id="home">
    <div class="container">
        <div class="banner-content col-lg-8 col-md-12">
            <p class="banner-area-top-text text-uppercase text-box">{effect_phrase}</p>
            <h1 class="banner-area-company text-box">{company_name}</h1>
            <p class="banner-area-description text-box">{description}</p>
            <table width="100%" border="0">
                <tr>
                    <td>
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a on:click="{()=>scrowTo('monte-seu-pedido')}" class="btn btn-primary landing-btn text-uppercase">
                            Veja como fazer o seu pedido
                        </a>
                    </td>
                    <td>
                        <a href="{delivery_url}" class="btn btn-primary landing-btn text-uppercase">
                            Pedido Online
                        </a>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</section>
